module.exports = __webpack_public_path__ + "static/media/college.2fb6082a.jpeg";